/**
 * External dependencies
 */
import { combineReducers } from "redux";
import moment from "moment";
import { compact } from "lodash";

/**
 * Internal dependencies
 */
import * as actions from "state/action-types";
import { createReducer } from "state/utils";
import dateParser from "lib/date-parser";

const date = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    return actions.payload.dateRange;
  },
});

const startDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange } = actions.payload;
    if (dateRange) {
      try {
        let dates = dateParser(dateRange);
        return moment(dates[0]).format("YYYY-MM-DD:HH:mm:ss");
      } catch (error) {}
    }
    return actions.payload.startDate || null;
  },
});

const endDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange } = actions.payload;
    if (dateRange) {
      try {
        let dates = dateParser(dateRange);
        return moment(dates[1]).format("YYYY-MM-DD");
      } catch (error) {}
    }
    return actions.payload.endDate || null;
  },
});

const compareType = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { compareType } = actions.payload;
    return compareType || "previous";
  },
});

const compareDate = createReducer(null, {
  [actions.SET_DATE_RANGE]: (state, actions) => {
    const { dateRange, startDate, endDate, compareType } = actions.payload;

    let mStart;
    let mEnd;

    if (dateRange) {
      try {
        let dates = dateParser(dateRange);

        mStart = moment(dates[0]);
        mEnd = moment(dates[1]);
      } catch (error) {}
    } else {
      mStart = moment(startDate);
      mEnd = moment(endDate);
    }

    // there always needs to be atleast 1 day difference, otherwise if the user selects
    // a single date, the comparision date will be the same
    let dif = mEnd.diff(mStart, "days");
    dif = dif === 0 ? 1 : dif;

    if (false === mStart.isValid() || false === mEnd.isValid()) {
      return null;
    }

    // probaly need some logic to check if its a leap year
    return compact([
      mStart
        .subtract(compareType === "last_year" ? 366 : dif, "days")
        .format("YYYY-MM-DD"),
      mEnd
        .subtract(compareType === "last_year" ? 366 : dif, "days")
        .format("YYYY-MM-DD"),
    ]);
  },
});

export default combineReducers({
  date,
  startDate,
  endDate,
  compareDate,
  compareType,
});
